<template>
  <div id="app">
    <router-view/>
    <div class="footer-main" :class="routeBgClass">
      <span>备案号：</span>
      <a href="http://beian.miit.gov.cn" target="_blank">渝ICP备2024021358号-4</a>
    </div>
  </div>
</template>

<script>
    export default {
        computed: {
            routeBgClass () {
                // 蓝色背景页面（你改成自己的路由）
                const bluePages = ['/login']
                if (bluePages.includes(this.$route.path)) {
                    return 'blue-bg-page'
                } else {
                    return 'white-bg-page'
                }
            }
        }
    }
</script>
<style>
  html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    min-width: 1000px;
    min-height: 500px;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;
    width: 100%;
    height: 100%;
  }

  .footer-main {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    text-align: center;
    padding: 5px 0;
    font-size: 14px;
    background: transparent;
  }

  .footer-main > a {
    text-decoration: none;
  }

  .footer-main > a:hover {
    text-decoration: underline;
  }

  .white-bg-page > span, .white-bg-page > a {
    color: #888888 !important;
  }

  .blue-bg-page > span {
    color: #CCCCCC !important;
  }

  .blue-bg-page > a {
    color: #EEEEEE !important;
  }

  .el-image-viewer__canvas {
    width: 98% !important;
    height: 98% !important;
    margin-top: 1%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
